// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210303/js/" + chunkId + "." + {"44":"48963a02","225":"94b43d21","481":"4a28c8a5","486":"4d3cf718","770":"6fbd8603"}[chunkId] + ".0.9545748090769266.chunk.js";
};